"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _en_US = _interopRequireDefault(require("antd/lib/locale-provider/en_US"));
var _a, _b;
if (!_en_US["default"].TreeSelect) {
  _en_US["default"].TreeSelect = {
    searchPlaceholder: 'Search'
  };
}
_en_US["default"].TreeSelect = (0, _extends2["default"])((0, _extends2["default"])({}, _en_US["default"].TreeSelect), {
  all: 'All'
});
if (!_en_US["default"].Select) {
  _en_US["default"].Select = {};
}
_en_US["default"].Select = (0, _extends2["default"])((0, _extends2["default"])({}, _en_US["default"].Select), {
  all: 'All',
  searchPlaceholder: 'Search'
});
_en_US["default"].LocaleEditor = {
  title: 'Internationalization',
  iconTips: 'This field can be internationalized',
  unset: 'Unset',
  set: 'Set',
  label: {
    'zh-CN': 'Chinese(zh-CN)',
    'en-US': 'English(en-US)',
    'de-DE': 'German(de-DE)'
  }
};
_en_US["default"].Table = (0, _extends2["default"])((0, _extends2["default"])({}, _en_US["default"].Table), {
  hasSelected: 'Selected',
  columnsTitle: 'Edit Columns',
  save: 'Save',
  cancel: 'Cancel',
  resetColumnsModalTitle: 'Restore to default view?',
  resetColumnsModalContent: 'Custom configurations cannot be recovered after restoration.'
});
_en_US["default"].Pagination = (0, _extends2["default"])((0, _extends2["default"])({}, _en_US["default"].Pagination), {
  items_per_page: '/ Page'
});
_en_US["default"].DatePicker = (0, _extends2["default"])((0, _extends2["default"])((0, _extends2["default"])({}, _en_US["default"].DatePicker), {
  lang: (0, _extends2["default"])((0, _extends2["default"])({}, ((_a = _en_US["default"].DatePicker) === null || _a === void 0 ? void 0 : _a.lang) || {}), {
    placeholder: 'Date',
    yearPlaceholder: 'Year',
    quarterPlaceholder: 'Quarter',
    monthPlaceholder: 'Month',
    weekPlaceholder: 'Week'
  }),
  timePickerLocale: (0, _extends2["default"])((0, _extends2["default"])({}, ((_b = _en_US["default"].DatePicker) === null || _b === void 0 ? void 0 : _b.timePickerLocale) || {}), {
    placeholder: 'Time'
  })
}), {
  rangeTimePlaceholder: ['Start Time', 'End Time']
});
var _default = exports["default"] = _en_US["default"];